module.exports = __webpack_public_path__ + "static/img/Daly-Cherry-Evans.384bc2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Daly-Cherry-Evans.jpg
// module id = pJ7Y
// module chunks = 0